import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getTenantAccessAllEvents } from '../api/tenantAccessApi';
import { DataTable } from '../components/DataTable';
import { ErrorState } from '../components/ErrorState';
import { LoadingState } from '../components/LoadingState';
import { PageShell } from '../components/PageShell';

export function TenantAccessEventsPage() {
  const { t } = useTranslation(['tenantAccess', 'common']);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await getTenantAccessAllEvents({ per_page: 100 });
      setRows(response.data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const columns = useMemo(() => [
    { id: 'tenant_id', label: t('tenantAccess:events.columns.tenant') },
    { id: 'event_type', label: t('tenantAccess:events.columns.event') },
    { id: 'reason_code', label: t('tenantAccess:dashboard.columns.reason') },
    { id: 'message', label: t('tenantAccess:events.columns.message') },
    { id: 'created_at', label: t('tenantAccess:events.columns.at') },
  ], [t]);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState message={t('tenantAccess:events.load_failed')} onRetry={load} />;
  }

  return (
    <PageShell title={t('tenantAccess:events.title')} subtitle={t('tenantAccess:events.subtitle')}>
      <DataTable columns={columns} rows={rows} rowKey="id" emptyMessage={t('tenantAccess:events.no_events')} />
    </PageShell>
  );
}
